import React from 'react';
import { Button, Typography, Box } from '@mui/material';
import { Container, Paper } from '@mui/material';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';

const NotFoundPage = () => {
  const history = useHistory();
  return (
    <Container
      component='main'
      maxWidth='md'
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80vh'
      }}
    >
      <Paper elevation={3} sx={{ p: 5, textAlign: 'center', borderRadius: 3 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2
          }}
        >
          <AnnouncementOutlinedIcon
            sx={{ fontSize: 70, color: 'error.main' }}
          />
          <Typography
            variant='h2'
            sx={{ color: 'primary.main', fontSize: '58' }}
          >
            404
          </Typography>
          <Typography
            sx={{ fontSize: 20 }}
            variant='button'
            color='textSecondary'
          >
            Oops! The page you’re looking for doesn’t exist.
          </Typography>
          <Button
            variant='contained'
            color='primary'
            sx={{ mt: 2, borderRadius: 2 }}
            onClick={() => history.push('/')}
          >
            Go to Home
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default NotFoundPage;
